// Public customer destination only. Saved sourceUrl evidence remains unchanged.
module.exports={FLORIDA_RESULTS_PAGE:'https://floridalottery.com/games/winning-numbers'};
